import { create } from 'zustand';
import { AIDataType } from "../../types/Writer/AIData.ts";
import { SelectContent } from "../../types/Writer/SelectContents.ts";

// 高亮状态接口
export interface HighlightState {
  nodeId: string | number | null;  // 当前高亮的节点 ID
  selectContent: string | null;     // 当前高亮的文本内容
  cardRect: DOMRect | null;         // 卡片的位置信息（用于画箭头）
}

interface CounterState {
  aiType: AIDataType | null;
  updateAiType: (newOutline: AIDataType | null) => void;
  selectContentArr: SelectContent[]
  setSelectContentArr: (newSelectContentArr: SelectContent[]) => void
  aiDataCache: Map<number, any> // todo: 还要与currentSectionIndex绑定，滚动切换
  setAiDataCache: (id: number, newAiDataCache: any) => void
  // 高亮状态
  highlightState: HighlightState;
  setHighlightState: (state: HighlightState) => void;
  clearHighlight: () => void;
}

const useAiTypeStore = create<CounterState>((set) => ({
  aiType: null,
  updateAiType: (newAiType) => set(() => ({ aiType: newAiType })),
  selectContentArr: [],
  setSelectContentArr: (newSelectContentArr) => set(() => ({ selectContentArr: newSelectContentArr })),
  aiDataCache: new Map(),
  setAiDataCache:(id: number, newAiDataCache: any) => set((state) => {
    const updatedMap = state.aiDataCache;
    updatedMap.set(id, newAiDataCache);
    return { aiDataCache: updatedMap };
  }),
  // 高亮状态初始值
  highlightState: {
    nodeId: null,
    selectContent: null,
    cardRect: null,
  },
  setHighlightState: (newState) => set(() => ({ highlightState: newState })),
  clearHighlight: () => set(() => ({
    highlightState: { nodeId: null, selectContent: null, cardRect: null }
  })),
}))

export default useAiTypeStore;

